// extracted by mini-css-extract-plugin
export default {"card":"AccountEdit_card__Si4ue","documentWrapper":"AccountEdit_documentWrapper__rkemd"};